export const toLocaleString = (date: string | null | undefined, options = {} , lang = 'en-us') => date && new Date(date).toLocaleString(lang, options);
